import React from 'react';
import styles from './styles/Header.module.css';
import logo from '../imgs/logo-header.png';

export default class Component extends React.PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <img src={logo} className={styles.logo} alt="logo" />
      </div>
    )
  }
}